import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
};

export const NoResultsFoundIcon = ({ sx }: Props) => {
	return (
		<SvgIcon width='121' height='122' viewBox='0 0 121 122' fill='none' sx={sx}>
			<svg xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M0 60.8298C0 27.6928 26.8629 0.829834 60 0.829834V0.829834C93.1371 0.829834 120 27.6928 120 60.8298V60.8298C120 93.9669 93.1371 120.83 60 120.83V120.83C26.8629 120.83 0 93.9669 0 60.8298V60.8298Z'
					fill='var(--mui-palette-background-default)'
				/>
				<rect
					x='61.9998'
					y='68.7483'
					width='8.65126'
					height='63.0306'
					rx='4.32563'
					transform='rotate(-45 61.9998 68.7483)'
					fill='var(--mui-palette-primary-light)'
				/>
				<path
					d='M103.2 104.958L113.1 114.858'
					stroke='var(--mui-palette-background-paper)'
					strokeWidth='4.2'
					strokeMiterlimit='10'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<circle
					cx='52.5'
					cy='50.0585'
					r='38.1'
					fill='var(--mui-palette-background-paper)'
				/>
				<ellipse
					cx='52.5512'
					cy='49.5457'
					rx='32.7512'
					ry='33.9871'
					fill='var(--mui-palette-primary-lighter)'
				/>
				<path
					d='M28.2 51.5584C28.2 63.4878 38.6765 73.1584 51.6 73.1584'
					stroke='var(--mui-palette-background-paper)'
					strokeWidth='4.2'
					strokeMiterlimit='10'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<rect
					x='86.7176'
					y='93.4661'
					width='8.65126'
					height='38.417'
					rx='1.2'
					transform='rotate(-45 86.7176 93.4661)'
					fill='var(--mui-palette-primary-lighter)'
					stroke='var(--mui-palette-primary-main)'
					strokeWidth='1.8'
					strokeMiterlimit='10'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<circle
					cx='52.7305'
					cy='49.6533'
					r='37.6948'
					stroke='var(--mui-palette-primary-main)'
					strokeWidth='1.8'
					strokeMiterlimit='10'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M52.8 19.1584C35.9001 19.1584 22.2 32.8585 22.2 49.7584C22.2 66.6584 35.9001 80.3584 52.8 80.3584C60.8021 80.3584 68.0867 77.2869 73.5393 72.2584C77.0118 69.0561 79.7412 65.0602 81.4396 60.5584M72.6 26.427C75.6984 29.059 78.2658 32.2973 80.1189 35.9584'
					stroke='var(--mui-palette-primary-main)'
					strokeWidth='1.8'
					strokeMiterlimit='10'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</svg>
		</SvgIcon>
	);
};
